/**
 * Sign-in screen (REAL mode, unauthenticated). The AuthProvider renders this when Auth0 reports no
 * session, handing in a `login` callback that triggers the Authorization-Code + PKCE redirect. In
 * MOCK mode the app is always "authenticated", so this is shown only against a real Auth0 tenant.
 *
 * Intentionally minimal: brand mark, one sentence of what this is, one primary action. No marketing.
 */

import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui";

export interface SignInProps {
  /** Starts the Auth0 redirect login. */
  onSignIn: () => void;
}

export function SignIn({ onSignIn }: SignInProps) {
  const { t } = useTranslation();

  return (
    <main className="flex min-h-dvh items-center justify-center bg-(--bg) px-4">
      <div className="flex w-full max-w-sm flex-col items-center gap-7 rounded-(--radius-lg) border border-(--border) bg-(--surface) px-8 py-10 text-center shadow-(--shadow-lg)">
        <span
          className="flex size-12 items-center justify-center rounded-(--radius) bg-(--brand) text-(--text-onbrand) shadow-(--shadow-sm)"
          aria-hidden
        >
          <span className="text-(length:--text-lg) font-bold tracking-tight">Z</span>
        </span>

        <div className="flex flex-col gap-1.5">
          <h1 className="text-(length:--text-xl) font-semibold text-(--text-strong)">
            {t("app.name")}
          </h1>
          <p className="text-(length:--text-sm) text-(--text-muted)">{t("app.tagline")}</p>
        </div>

        <Button size="lg" onClick={onSignIn} className="w-full">
          {t("auth.signIn")}
        </Button>

        <p className="text-(length:--text-2xs) text-(--text-subtle)">{t("auth.staffOnly")}</p>
      </div>
    </main>
  );
}
